<div
  class="flex grid-cols-2 flex-col items-center gap-4 md:grid md:justify-between"
>
  <h2
    class="text-nowrap text-2xl font-extrabold leading-[1.3125rem] text-mango-black17"
  >
    Facial Recognition Log
  </h2>
</div>

<div class="flex gap-3">
  <app-filters [filters]="filterStructure"></app-filters>
  <app-table-refresh class="mt-5" [tableKey]="'facialRecognitionLog'"></app-table-refresh>
</div>

<!-- table skeleton loader -->
@if (isFetchingList$ | async) {
<div class="mt-[0.94rem]">
  <app-table-skeleton-loader></app-table-skeleton-loader>
</div>
}

<!-- Table -->
@if (!(isFetchingList$ | async)) {
<div
  *appHasPermission="'can_get_face_recognition_log'"
  class="mt-[0.94rem] rounded-lg border border-solid border-mango-gray200 bg-white"
>
  <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
    <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
      <div
        class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg"
      >
        <table class="min-w-full leading-normal">
          <thead>
            <tr>
              <th
                class="flex border-b-2 border-gray-200 bg-gray-100 px-5 py-5 text-left text-xs font-semibold text-gray-600"
              >
                S/N
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M7.99998 3.33301V12.6663M7.99998 12.6663L12.6666 7.99967M7.99998 12.6663L3.33331 7.99967"
                    stroke="#667085"
                    stroke-width="1.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </th>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                Name
              </th>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                Time
              </th>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                Reason
              </th>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                Status
              </th>
            </tr>
          </thead>

          <tbody>
            @if ((facialRecognitionLogList$ | async)?.length > 0) {
              @for (
                log of facialRecognitionLogList$ | async;
                track log;
                let i = $index
              ) {
                <tr>
                  <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                    <p>{{ i + 1 }}</p>
                  </td>
                  <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                    <p class="whitespace-no-wrap text-gray-900">
                      {{ getName(log.user) }}
                    </p>
                  </td>
                  <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                    <p class="whitespace-no-wrap text-gray-900">
                      {{ log.timestamp ? (log.timestamp | date: 'dd MMM yyyy, HH:mm') : '-' }}
                    </p>
                  </td>
                  <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                    <p class="whitespace-no-wrap text-gray-900">
                      {{ log.reason || '-' }}
                    </p>
                  </td>
                  <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                    <span
                      class="relative inline-block px-2 py-1 font-semibold leading-tight text-green-900 sm:px-2"
                    >
                      <span
                        aria-hidden
                        class="absolute inset-0 {{
                          log.status === 'success'
                            ? 'bg-green-400'
                            : log.status === 'failed'
                              ? 'bg-red-300'
                              : 'bg-yellow-400'
                        }} opacity-50 rounded-full"
                      ></span>
                      <span
                        class="relative flex {{
                          log.status === 'success'
                            ? 'text-green-700'
                            : log.status === 'failed'
                              ? 'text-red-900'
                              : 'text-yellow-900'
                        }} sm:text-[11px]"
                      >
                        {{ log.status | uppercase }}
                      </span>
                    </span>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>

        <app-table-navigator
          *ngIf="totalCount$ | async as totalCount"
          [total]="totalCount"
          (onNavigation)="navigate($event)"
        ></app-table-navigator>
      </div>
    </div>
  </div>
</div>
}
